// FIXME: move out of the blog
import React from 'react';
import WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import WordpressConverter from './utils/WordpressConverter';
import RelatedArticlesContainer from './RelatedArticlesContainer';

interface RelatedArticlesWordpressContainerProps {
  userId: string;
  posts: WordpressPost[];
}

// TODO: this component should be deleted after the migration
function RelatedArticlesWordpressContainer({ posts }: RelatedArticlesWordpressContainerProps): JSX.Element {
  return <RelatedArticlesContainer articleLinks={posts.map(post => WordpressConverter.convertPost(post))} />;
}

export default RelatedArticlesWordpressContainer;
